import { render, staticRenderFns } from "./admin-registry.vue?vue&type=template&id=a1bfd070&lang=pug&"
import script from "./admin-registry.vue?vue&type=script&lang=js&"
export * from "./admin-registry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports